export const SET_NIOX_FENO_IPC_INITIALIZED = "SET_NIOX_FENO_IPC_INITIALIZED";

export const SET_NIOX_FENO_VIEW = "SET_NIOX_FENO_VIEW";

export const SET_NIOX_FENO_PAIRED_FENO_DEVICE_SERIAL_NUMBER = "SET_NIOX_FENO_PAIRED_FENO_DEVICE_SERIAL_NUMBER";

export const SET_NIOX_FENO_CONNECTION_ATTEMPTS = "SET_NIOX_FENO_CONNECTION_ATTEMPTS";

export const SET_NIOX_FENO_STATUS_REPORT = "SET_NIOX_FENO_STATUS_REPORT";

export const SET_NIOX_FENO_CONNECTION_UNSTABLE = "SET_NIOX_FENO_CONNECTION_UNSTABLE";

export const SET_NIOX_FENO_SIMULATE_CONNECTION = "SET_NIOX_FENO_SIMULATE_CONNECTION";

export const SET_NIOX_FENO_SIMULATE_MEASUREMENT = "SET_NIOX_FENO_SIMULATE_MEASUREMENT";

export const RESET_NIOX_FENO_STATE = "RESET_NIOX_FENO_STATE";

export const SET_FENO_TYPE = "SET_FENO_TYPE";

export const SET_LANGUAGE_CODE = "SET_LANGUAGE_CODE";

export const SET_FENO_TRANSLATIONS = "SET_FENO_TRANSLATIONS";

export const SET_FENO_DEFAULT_TRANSLATIONS = "SET_FENO_DEFAULT_TRANSLATIONS";

export const SET_FENO_COLLECTIONID = "SET_FENO_COLLECTIONID";

export const SET_LABELS_MEASUREMENT = "SET_LABELS_MEASUREMENT";

export const SET_FENO_VISIT_LABELS = "SET_FENO_VISIT_LABELS";

export const SET_FENO_IQC_PERSIST_STATUS = "SET_FENO_IQC_PERSIST_STATUS";